import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

/**
 * Role-based route component
 * Redirects users to appropriate routes based on their role
 */
const RoleBasedRoute = ({ children, allowedRoles = [] }) => {
  const user = authService.getCurrentUser();
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If no specific roles required, allow all authenticated users
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check if user's role is in allowed roles
  if (user?.role && allowedRoles.includes(user.role)) {
    return children;
  }

  // Redirect based on role
  const roleRedirects = {
    employee: '/vacancies',
    company: '/company/vacancies',
    recruitment_company: '/recruitment-company/vacancies',
    admin: '/dashboard',
  };

  const redirectPath = roleRedirects[user?.role] || '/vacancies';
  return <Navigate to={redirectPath} replace />;
};

export default RoleBasedRoute;



